import Button from "../../components/common/button/Button";
import SubHeader from "../../components/header/SubHeader";
import React, {useEffect, useState} from "react";
import {useLocation, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getValidatedLimit} from "../../components/Utility";
import {fetchPurchaseById, fetchSettlementPurchase} from "../../store/purchase-slice";
import {fetchProductList, fetchVendorList} from "../../store/list-slice";
import {
    getOrderItemTableColumns,
    getOrderItemTableData,
    getSettlementTableColumns,
    getSettlementTableData
} from "../../models/purchaseModel";
import Table from "../../components/common/table/Table";
import {getDetailData} from "../../models/purchaseModel";
import Detail from "../../components/common/detail/Detail";
import Stack from "../../components/ui/Stack";

const ProductDetail = () => {

    const params = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    const list = useSelector(state => state.list);
    const {items: productList} = list.product;
    const {items: vendors} = list.vendor;
    const {pagination} = useSelector(state => state.purchase);
    const [showSettlement, setShowSettlement] = useState(false);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        if (params.purchaseId) {
            dispatch(fetchPurchaseById({...userRole, id: params.purchaseId}));
            dispatch(fetchProductList(userRole));
            dispatch(fetchVendorList(userRole));
        }
    }, [dispatch, params.purchaseId, userRole]);

    const {
        items,
        settlement,
        fetchByIdStatus,
        fetchSettlementStatus,
        error
    } = useSelector(state => state.purchase);

    const item = items.find(item => item.id === params.purchaseId);
    const products = item?.products || [];

    const viewSettlementHandler = () => {
        setShowSettlement(true);
        dispatch(fetchSettlementPurchase({...userRole, id: params.purchaseId}))
    }

    //Purchase product derails table data
    const tableColumns = getOrderItemTableColumns();

    const tableData = getOrderItemTableData({products, productList});

    //Settlement table data
    const tableSettlementColumns = getSettlementTableColumns();
    const tableSettlementData = getSettlementTableData({settlement});

    const detailData = getDetailData({item, vendors});

    // Define fallback URL if no state is present
    const fallbackUrl = `../?page=${currentPage}&limit=${limit}`;
    const stateUrl = location.state?.from || fallbackUrl;

    return (
        <>
            <SubHeader title="Purchase Details">
                <Button
                    to={
                        stateUrl
                            ? stateUrl
                            : params.vendorId
                                ? `/vendor/${params.vendorId}/purchase?page=${currentPage}&limit=${limit}`
                                : `../?page=${currentPage}&limit=${limit}`
                    }
                    className="btn-sm bg-secondary bg-opacity-50"
                >
                    Back
                </Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" &&
                    <>
                        <Detail inline={true} columns={{lg: 9, xl: 7}} data={detailData}/>

                        <h6 className="mt-4">Order Items</h6>
                        <Table className="mobile-responsive" columns={tableColumns} data={tableData}/>

                        <Stack className="justify-content-end gap-2">
                            <Button className="d-block bg-success bg-opacity-50" onClick={viewSettlementHandler}>View
                                Settlements</Button>
                            <Button to={`/vendor/${item?.vendor}/getDue`}
                                    className="btn-sm bg-primary bg-opacity-50">Get
                                Dues</Button>
                        </Stack>


                        {showSettlement && (
                            <>
                                {fetchSettlementStatus === "loading" && <p>Loading settlements...</p>}
                                {fetchSettlementStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                                {fetchSettlementStatus === "success" && settlement.length > 0 && (
                                    <>
                                        <h6>Settlement Info</h6>
                                        <Table
                                            className="mobile-responsive"
                                            columns={tableSettlementColumns}
                                            data={tableSettlementData}
                                        />
                                    </>
                                )}
                                {fetchSettlementStatus === "success" && settlement.length === 0 && (
                                    <p>No settlements found.</p>
                                )}
                            </>
                        )}
                    </>
                }
            </div>
        </>
    )
}

export default ProductDetail;